export default "__VITE_ASSET__VRGXeHRp__"